






import { Component, Prop, Vue } from 'vue-property-decorator';
import { pageClicked } from '@utils/analytics';

@Component
export default class AsyncButton extends Vue {
	@Prop({ default: 'button-fundrise-orange' })
	classes!: string;

	@Prop()
	isWorking!: boolean;

	get buttonClasses(): string {
		if (this.isWorking) {
			return `${this.classes} active button-loading`;
		}

		return `${this.classes}`;
	}

	onClick($event: Event): void {
		if (!this.isWorking) {
			const slot = this.$slots?.default ?? undefined;
			pageClicked({ slot });
			this.$emit('click', $event);
		}
	}
}
